import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Item = styled.div`
  background: ${theme.colors.SurfaceCultured10};
  padding: 8px 16px;
  border-radius: 8px;
  width: 100%;
  height: 43px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  p {
    text-wrap: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Hotkeys = styled.div`
  display: flex;
  flex-direction: row;
  gap: 14px;
  height: 100%;
`;

export const HotkeyItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  color: ${theme.colors.NarcissusYellow};
`;

export const VertDivider = styled.div<{ color?: string; width?: number }>`
  width: ${({ width }) => width ?? 1}px;
  border-left: 1px solid ${({ color }) => color ?? theme.colors.SurfacePlatinum20};
  background-color: ${({ color }) => color ?? theme.colors.SurfacePlatinum20};
`;
